import { List } from 'immutable';
import React from 'react';

/**
 * render array or list of strings into an array of paragraphs
 *
 * @param {...(Array|List)} arrayOrList - array or list of strings
 * @returns {Array} array of paragraphs
 */
export function renderParagraph(
  arrayOrList: string[] | List<string>,
): React.ReactElement[] | undefined {
  if (!arrayOrList) {
    return;
  }
  const paragraphEls = arrayOrList.map((value, index) => {
    return <p key={index}>{value}</p>;
  });

  return paragraphEls instanceof Array ? paragraphEls : paragraphEls.toArray();
}

export function arrayClearElement(
  array: React.ReactElement[],
  elem: React.ReactElement,
): React.ReactElement[] | void {
  if (array && array.includes(elem)) {
    array.splice(array.indexOf(elem), 1);
  }
}

export function makeSparseArray(total: number, valFunc: $TSFixMeFunction): $TSFixMe[] {
  const sparse = [];
  for (let i = 0; i < total; i++) {
    sparse[i] = valFunc(i);
  }
  return sparse;
}

/**
 * Performs a union on given an immutable lists, removing duplicates
 *
 * @param {*} args - Accepts immutable Lists
 * @returns {Immutable.List}
 */
// TODO WEBCA-1926: remove dead code after curator project is launched
export function union(...args: $TSFixMe): $TSFixMe {
  return args.reduce((accumulator: $TSFixMe, current: $TSFixMe) => {
    if (current) {
      const noDupes = current.filter((item: $TSFixMe) => {
        return item && accumulator.indexOf(item) < 0;
      });

      return accumulator.concat(noDupes);
    }

    return accumulator;
  }, List());
}
